import { render, staticRenderFns } from "./CheckboxElement.vue?vue&type=template&id=6e816c67&"
import script from "./CheckboxElement.vue?vue&type=script&lang=js&"
export * from "./CheckboxElement.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxElement.vue?vue&type=style&index=0&id=6e816c67&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports